import { JobTypeCode } from '@domain/constant/v1/jobType';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';

export class CompanyQuestionListFilterOption {
  jobTypeList: ReactSelectOption<JobTypeCode>[];
  jobGroupList: ReactSelectOption[];

  constructor() {
    this.jobTypeList = [];
    this.jobGroupList = [];
  }

  setFilter(name: CompanyQuestionFilterName, selectedFilterList: ReactSelectOption[]) {
    switch (name) {
      case CompanyQuestionFilterName.JOBTYPE:
        this.jobTypeList = selectedFilterList.map(
          (it) => ({ value: it.value, label: it.label } as ReactSelectOption<JobTypeCode>),
        );
        break;
      case CompanyQuestionFilterName.JOBGROUP:
        this.jobGroupList = selectedFilterList.map((it) => ({ value: it.value, label: it.label }));
    }
  }
}
export const dropDownCareerOptions: ReactSelectOption<JobTypeCode>[] = [
  { value: JobTypeCode.NEW, label: '신입' },
  { value: JobTypeCode.CAREER, label: '경력' },
];

export enum CompanyQuestionFilterName {
  JOBTYPE = 'jobTypeList',
  JOBGROUP = 'jobGroupList',
}
